// CreateUserForm.jsx
import React, { useState } from 'react';
import { Button, TextField, Container, Typography } from '@mui/material';
import { getFunctions, httpsCallable } from 'firebase/functions';

const CreateUserForm = ({ onUserCreated }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [roles, setRoles] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const functions = getFunctions();
  const createUserAccount = httpsCallable(functions, 'createUserAccount');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Convert a comma-separated list of roles to an array.
      const rolesArray = roles.split(',').map(r => r.trim()).filter(r => r);
      const result = await createUserAccount({ email, password, roles: rolesArray });
      console.log('User created:', result.data);
      onUserCreated();
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <Container>
      <Typography variant="h5">Create New User</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Password"
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Roles (comma-separated)"
          value={roles}
          onChange={e => setRoles(e.target.value)}
          fullWidth
          margin="normal"
        />
        {error && <Typography color="error">{error}</Typography>}
        <Button type="submit" variant="contained" color="primary" disabled={loading}>
          Create User
        </Button>
      </form>
    </Container>
  );
};

export default CreateUserForm;
